import http from "./httpService";
const apiEndpoint = "/analyze";

function getUrl(apiKey, url) {
  return `${apiEndpoint}?key=${apiKey}&url=${url}`;
}
export function analyze(apiKey, url) {
  return http.get(getUrl(apiKey, url));
}
